module.exports = __webpack_public_path__ + "assets/ic-bsс.4eb5ffba.svg";